import { Plus } from "lucide-react";
import { Button } from "../ui/button";

export function TasksHeader({ pendingCount, onAddTask }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div>
        <h1 className="text-3xl font-bold text-white font-['Outfit']">Tasks</h1>
        <p className="text-slate-400 mt-1">{pendingCount} pending tasks</p>
      </div>
      <Button
        onClick={onAddTask}
        className="bg-indigo-600 hover:bg-indigo-500 glow-primary"
        data-testid="add-task-button"
      >
        <Plus size={18} className="mr-2" />
        Add Task
      </Button>
    </div>
  );
}
